module.exports = __webpack_public_path__ + "static/img/card1.7553770.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/card1.jpg
// module id = PW2d
// module chunks = 0